export function createReconnectWatchdog({
  nav,
  onReconnect,
  maxWindowMs = 30000,
  capMs = 8000,
}) {
  let timer = null;
  let delay = 500;
  let elapsed = 0;
  let stopped = false;

  const schedule = () => {
    elapsed += delay;
    if (elapsed >= maxWindowMs) return;
    delay = Math.min(delay * 2, capMs);
    timer = setTimeout(tryOnce, delay);
  };

  const tryOnce = () => {
    if (stopped) return;

    nav.serial
      .getPorts()
      .catch(() => [])
      .then((ports) => {
        if (stopped) return;

        if (ports && ports.length) {
          // One-shot per detection: fires onReconnect once for the first available
          // port and stops polling. It does NOT retry if the resulting connect
          // attempt fails — the caller owns retry/restart.
          onReconnect(ports[0]);
        } else {
          schedule();
        }
      });
  };

  const onConnect = () => {
    if (!stopped) tryOnce();
  };

  return {
    start() {
      stopped = false;
      delay = 500;
      elapsed = 0;
      nav.serial.addEventListener?.('connect', onConnect);
      tryOnce();
    },

    stop() {
      stopped = true;
      clearTimeout(timer);
      nav.serial.removeEventListener?.('connect', onConnect);
    },
  };
}
